/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {

    declare var CustomStyle: any;
    declare var modelSelf: PdfGenerationConfigurationModel;

    export class PdfGenerationConfigurationModel {

        public isEditing: boolean = false;
        public progress: number;
        public selectedPdf: models.PdfBinding;
        public fileUploadModel: models.FileUploadModel;
        public newPdfModel: models.FileUploadModel;
        public showConfigureBindings: boolean = false;
        public activePageIndex: number = 0;
        public processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        public newPdfdocuments: Array<any>;
        
        constructor(
            private scope: angular.IScope,
            private $route: angular.route.IRouteService,
            private processConfigurationId: string,
            private pdfBindingService: services.PdfBindingService,
            private boundItemService: services.BoundItemService,
            private processConfigurationService: services.ProcessConfigurationService,
            private treeService: services.TreeService,
            private deleteService: services.DeleteService) {

            this.fileUploadModel = new models.FileUploadModel();
            this.newPdfModel = new models.FileUploadModel();

            this.newPdfdocuments = [];
            
            if (processConfigurationId) {
                processConfigurationService.getWorkflowExpandFieldsAndPdfBindings(processConfigurationId).then(
                    (processConfig) => {
                        this.processConfiguration = processConfig;
                    });
            }

            modelSelf = this;

            scope.$watch("model.selectedPdf.documents[0]", () => {
                modelSelf.fileUploaded();
            });

            scope.$watch("model.newPdfdocuments[0]", () => {
                modelSelf.newPdfUploaded();
            });
        }

        public saveChanges() {
            this.processConfigurationService.saveAllChanges();
        }

        private newPdfUploaded() {
            if (!this.newPdfdocuments || this.newPdfdocuments.length === 0) return;
            if (this.newPdfdocuments[0].id <= 0) return;

            this.selectedPdf.staticDocument_id = modelSelf.newPdfdocuments[0].id;
            this.processConfigurationService.saveAllChanges(() => {
                this.$route.reload();
            });
        }

        private fileUploaded() {
            if (!modelSelf.selectedPdf|| !modelSelf.selectedPdf.documents || modelSelf.selectedPdf.documents.length === 0) {
                return;
            }

            if (modelSelf.selectedPdf.documents[0].id <= 0) return;

            modelSelf.showConfigureBindings = true;
            modelSelf.selectedPdf.staticDocument_id = modelSelf.selectedPdf.documents[0].id;
            modelSelf.configureBindings();
            modelSelf.saveChanges();
        }

        public addPdf() {
            this.isEditing = true;
            this.selectedPdf = this.pdfBindingService.createPdfBinding();
            if (!this.processConfiguration.myPdfBindings) {
                this.processConfiguration.myPdfBindings = [];
            }
            this.processConfiguration.myPdfBindings.push(this.selectedPdf);
            this.selectedPdf.processConfiguration_id = this.processConfigurationId;
            this.selectedPdf.documents = [];
        }

        public configurePdf(pdfBind: models.PdfBinding) {
            this.selectedPdf = pdfBind;
            this.showConfigureBindings = true;
            this.isEditing = true;
            this.configureBindings();
        }

        public delete(pdfBind: models.PdfBinding) {

            this.deleteService.deleteWithModalConfirmationIfNecessary(
                "PdfBinding",
                pdfBind.id,
                "Successfully deleted PDF Binding",
                undefined,
                "Could not delete PDF Binding");
        }

        public onDrop($event, boundItem: models.BoundItem) {
            var treeItem = this.treeService.createTreeItemFromItemDropped();

            boundItem.treeItem = treeItem; 
            boundItem.treeItem_id = treeItem.id;

            this.treeService.clearDragValue();
            modelSelf.saveChanges();
        }

        private pageAnnotations: Array<any>;
        private page: any;
        private viewPort : any;

        public fixAnnotations(boundItem,rect) {
            var view = modelSelf.page.view;
                rect = (<any>PDFJS).Util.normalizeRect([
                    rect[0],
                    view[3] - rect[1] + view[1],
                    rect[2],
                    view[3] - rect[3] + view[1]]);

                boundItem.left = rect[0] + 15 + 'px';
                boundItem.top = rect[1] + 'px';
                boundItem.width = rect[2] - rect[0] + 'px';
                boundItem.height = rect[3] - rect[1] + 'px';
                boundItem.fontSize = rect[3] - rect[1] - 3 + 'px';
               
                var transform = modelSelf.viewPort.transform;

                var transformStr = 'matrix(' + transform.join(',') + ')';

                boundItem.transform = transformStr;

                var transformOriginStr = -rect[0] + 'px ' + -rect[1] + 'px';
                boundItem.transformOrigin = transformOriginStr;
        }

        private setupAnnotations(page, viewport, canvas, $annotationLayerDiv) {
            canvas = $('#thecanvas');
            $annotationLayerDiv.height(canvas.height());
            $annotationLayerDiv.width(canvas.width());
            $annotationLayerDiv.position({
                my: "left top",
                at: "left top",
                of: "#thecanvas"
            });

            var promise = page.getAnnotations().then(annotationsData => {
                modelSelf.pageAnnotations = annotationsData;

                viewport = viewport.clone({
                    dontFlip: true
                });
                modelSelf.viewPort = viewport;

                for (var i = 0; i < annotationsData.length; i++) {
                    var data = annotationsData[i];

                    var boundItem = <BoundItem>Enumerable.from(modelSelf.selectedPdf.currentPage.boundItems)
                        .singleOrDefault(x => x.pdfInputFieldKey === data.fullName);
                   
                    if (!boundItem) {
                        boundItem = modelSelf.boundItemService.createBoundItem();
                        boundItem.pdfInputFieldKey = data.fullName;
                        boundItem.pdfInputFieldDisplayName = data.alternativeText;

                        modelSelf.selectedPdf.currentPage.boundItems.push(boundItem);
                    }

                    var rect = data.rect;
                    modelSelf.fixAnnotations(boundItem,rect);
                }
                modelSelf.scope.$apply();
                modelSelf.saveChanges();
            });
            return promise;
        }

        public getTreeItemName(treeItem: Wars.Domain.Model.TreeItem): string {
            return treeItem !== undefined && treeItem !== null
                ? this.treeService.getDisplayName(treeItem)
                : "";
        }

        public configureBindings() {
            if (modelSelf.selectedPdf.id) {
                modelSelf.selectedPdf.entityAspect.loadNavigationProperty("pages").then(r => {
                    setTimeout(r => {
                        modelSelf.getPdf(modelSelf.selectedPdf.staticDocument_id);
                    }, 1000);

                });
            } else {
                modelSelf.getPdf(this.selectedPdf.documents[0].id);
            }
        }

        public range(length: number) {
            return new Array(length);
        }

        private getPdf(documentId) {
            if (documentId === undefined || documentId <= 0) return;
            PDFJS.getDocument('./api/document/StaticDocument/' + documentId)
                .then(pdf => {
                    modelSelf.selectedPdf.pdf = pdf;
                    modelSelf.selectedPdf.numberOfPages = pdf.numPages;
                    modelSelf.gotoPage(0);
                });
        }

        public reloadPage() {
            if (!modelSelf.selectedPdf || !modelSelf.selectedPdf.pages)
                return;

            this.gotoPage(this.activePageIndex);
        }

        public gotoPage(pageIndex: number) {
            modelSelf.activePageIndex = pageIndex;
            var pageNumber = pageIndex + 1;

            modelSelf.selectedPdf.pdf.getPage(pageNumber).then(page => {
                var binderPage = Enumerable.from(modelSelf.selectedPdf.pages).singleOrDefault(x => x.pageNumber === pageNumber);

                if (!binderPage) {
                    binderPage = modelSelf.pdfBindingService.createPdfBindingPage();
                    binderPage.pageNumber = pageNumber;
                    binderPage.pdfBinding_id = this.selectedPdf.id;
                    modelSelf.selectedPdf.pages.push(binderPage);
                    modelSelf.loadPage(binderPage, page);

                } else {
                    modelSelf.boundItemService.getBoundItemsWithTreeItems(binderPage.id).then(() => {
                        modelSelf.loadPage(binderPage, page);
                    });
                }
            });
        }

        private loadPage(binderPage,page) {
            modelSelf.selectedPdf.currentPage = binderPage;
            modelSelf.page = page;

            var scale = 1.5;
            var canvas : any = $('#thecanvas');
            scale = canvas.width() / modelSelf.page.getViewport(1.0).width;
            var viewport = page.getViewport(scale);
            modelSelf.viewPort = viewport;

            var canvas = <any>document.getElementById('thecanvas');

            canvas.height = viewport.height;
            canvas.width = viewport.width;
            var context = canvas.getContext('2d');
            var renderContext = {
                canvasContext: context,
                viewport: viewport
            };

            page.render(renderContext);
            this.setupAnnotations(page, viewport, canvas, $('#overlaypdf')); 
        }

        public deleteBoundItem(boundItem: Wars.Domain.Model.BoundItem) {
            this.deleteService.deleteWithModalConfirmIfNecessary(
                "BoundItem",
                boundItem.id,
                "PDF Binding",
                () => {
                    this.selectedPdf.currentPage.boundItems.remove(boundItem);
                });
        }
    }
}